import { useRoomStore } from '../../stores/room-store.js';
import { Button } from '../ui/Button.js';

export function ExpiryWarningBanner() {
  const expiryWarning = useRoomStore((s) => s.expiryWarning);
  const setExpiryWarning = useRoomStore((s) => s.setExpiryWarning);

  if (!expiryWarning) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-40 flex items-center justify-between gap-4 bg-yellow-900/90 border-b border-yellow-700 px-4 py-2 backdrop-blur-sm">
      <div className="flex items-center gap-2 text-sm text-yellow-200">
        <span>⚠️</span>
        <span>This room will close in <strong>5 minutes</strong>.</span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setExpiryWarning(false)}
        className="text-yellow-300 hover:text-yellow-100 shrink-0"
      >
        Dismiss
      </Button>
    </div>
  );
}
